// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3QxQl","productName":"Table_productName__3z3KT"};